$(document).foundation();

    //---------------------------------------------------------
    //  Dropdown Navigation Menu
    //---------------------------------------------------------
    $(document).on('click', '#nav-shade', function() {
        $('.icon-menu').removeClass('open');
        $('.menu-text').removeClass('open');
        $('#flyout-menu').removeClass('open');
        $('body').removeClass('menu-open');
        $('#nav-shade').fadeOut(300);


        $('.menu-text').html('MENU');

    });
    
    $(document).on('click', '#cart-shade', function() {
        $('#closeCart').trigger('click');
    });

    $(document).on('click', '.icon-menu, .menu-text', function() {
        if ($('body').hasClass('menu-open')) {
            $('#nav-shade').fadeOut(300);
            $('.menu-text').html('MENU');
        } else {
            $('#nav-shade').fadeIn(300);
            $('.menu-text').html('CLOSE');
        }

        $('.icon-menu').toggleClass('open');
        $('.menu-text').toggleClass('open');
        $('body').toggleClass('menu-open');
        $('#flyout-menu').toggleClass('open');
        return false;
    });

    $(document).on('click', '.btn-open-submenu', function() {
        let self = $(this);
        if (self.hasClass('open')) {
            self.html('+');
        } else {
            self.html('-');
        }
        self.parents('.nav-item').find('.sub-menu').toggleClass('mobile-open');
        self.toggleClass('open');
        
    });
  
    $(document).on('click','#showCart', function(e){

        $.ajax({
            type: 'GET',
            url: '/shoppingcart/load/',
            cache: false,
            data: {},
    
            beforeSend:function(){
                
            },
    
            dataType: 'json',
        })
        .done(function(data){
            $('#headerCart').replaceWith(data.response);
    
            setTimeout(function(){
                $("#headerCart").toggleClass('open');
                $('#cart-shade').fadeIn(300);
            }, 500);
        });
    });

    $(document).on('click','#closeCart', function(e){
        $("#headerCart").toggleClass('open');
        $('#cart-shade').fadeOut(300);
    });
    
    $(document).on('click', '.cart-qtyplus', function() {
        var fieldName = $(this).attr('field');
        var qty_field = $('input[name="'+fieldName+'"]');
        var currentVal = parseInt(qty_field.val());

        if (!isNaN(currentVal)) {
            currentVal += 1;
            qty_field.val(currentVal);
        } else {
            qty_field.val(0);
            currentVal=0;
        }

        var id = $(this).data('id');
        if(!isNaN(id)){
            $.ajax({
                type: 'GET',
                url: '/shoppingcart/setquantity/',
                cache: false,
                data: {'id':id, 'qty':currentVal},
                beforeSend:function(){
                    
                },
                dataType: 'json',
            }).done(function(data){
                UpdateCart();
            });
        }

    });

    $(document).on('click', '.cart-qtyminus', function() {
        var fieldName = $(this).attr('field');
        var qty_field = $('input[name="'+fieldName+'"]');
        var min = qty_field.attr('min');
        var currentVal = parseInt(qty_field.val());

        var canUpdate=true;
        if (!isNaN(currentVal) && currentVal > 0) {
            if(min){
                if(currentVal > min){
                    currentVal -= 1;
                }else{
                    currentVal = min;
                    canUpdate=false;
                }
            }else{
                currentVal -= 1;
            }

            qty_field.val(currentVal);
        } else {
            currentVal=0;
            qty_field.val(0);
        }

        var id = $(this).data('id');
        if(!isNaN(id)){
            $.ajax({
                type: 'GET',
                url: '/shoppingcart/setquantity/',
                cache: false,
                data: {'id':id, 'qty':currentVal},
                beforeSend:function(){
                    
                },
                dataType: 'json',
            }).done(function(data){
                UpdateCart();
            });
        }
    });

    $(document).on('click', '.nav-remove', function() {
        var id = $(this).data('id');
        
        if(!isNaN(id)){
            $.ajax({
                type: 'GET',
                url: '/shoppingcart/remove/',
                cache: false,
                data: {'id':id},
                beforeSend:function(){
                    
                },
                dataType: 'json',
            }).done(function(data){
                UpdateCart();
            });

            $('#item-row'+id).hide();
        }
    });

    function UpdateCart(){
        $.ajax({
            type: "GET",
            url: '/shoppingcart/getcart/',
            dataType: 'json',
            cache: false,
            data: {},
        })
        .done(function (data) {
            $('#cartsubtotal').html((Math.round(data.cartsubtotal * 100) / 100).toFixed(2));
            $('#navcartsubtotal').html((Math.round(data.cartsubtotal * 100) / 100).toFixed(2));
            $('#ordertax').html((Math.round(data.ordertax * 100) / 100).toFixed(2));

            console.log(data.orderdiscount);
            if(parseFloat(data.orderdiscount)>0){
                console.log('show');
                $('#orderdiscount').html((Math.round(data.orderdiscount * 100) / 100).toFixed(2));
                $('#discountdescription').html(data.discountdescription);
                $('#discount-row').show();
            }
            else{
                console.log('hide');

                $('#discount-row').hide();
            }
            
            $('#orderadditional').html((Math.round(data.orderadditional * 100) / 100).toFixed(2));
            $('#ordershipping').html((Math.round(data.ordershipping * 100) / 100).toFixed(2));
            $('#shopping-bag-total').html((Math.round(data.total * 100) / 100).toFixed(2));

            for (var i = 0; i < data.items.length; i++) {
                let record = data.items[i];
                $('#itemprice-'+record.id).html((Math.round(record.sellingprice * 100) / 100).toFixed(2));
                $('#navitemprice-'+record.id).html((Math.round(record.sellingprice * 100) / 100).toFixed(2));
                $('#itemtotal-'+record.id).html((Math.round(record.total * 100) / 100).toFixed(2));
            }
        })
        .fail (function (xhr) {
             //window.location.replace(".");
        });
    }// End UpdateCart

    $(document).on('click', '.link-expand', function() {
        $(this).parent().toggleClass('active');
    });

    $(document).on('click', '.link-shrink', function() {
        $(this).parent().parent().toggleClass('active');
    });

    $(document).on('click', '.sub-link-expand', function() {
        $(this).parent().parent().parent().find('.sub-cat').removeClass('active');
        $(this).parent().parent().toggleClass('active');
    });

    $(document).on('click','#showMobileSearch', function(e){
        $("#mobileSearch").toggleClass('open');
    });

    $(document).on('click','#cancelMobileSearch', function(e){
        $("#mobileSearch").toggleClass('open');
    });

    $(document).on('submit', '#newsletter-form', function(e) {
        e.preventDefault();
        
        var self = $(this);
        $.ajax({type: "GET", url: "/api/newslettersignup", dataType: 'json', data: self.serialize() })
        .done(function(data) {
    
        })
        .fail (function (xhr) {
            console.log('Error: ' + xhr.responseText);
        });
        
        $('#newsletter-form').hide();
        $('#newsletter-form-submit').show();
    });

    //---------------------------------------------------------
    //  Page Specific JS
    //---------------------------------------------------------
    
    if($('.ProductPage').length > 0) {
        
        $(document).ready(function() {
            if($('#product-group option').length<2){
                $('#product-group').hide();
            }

            $(".product-group-container").removeClass('active');
            $("#product-group-container"+$('#product-group').val()).addClass('active');
            LoadSelectedSku();
            $('.zoomImg').zoom();
        });

        $(document).on('change', '#product-group', function(e){
            $(".product-group-container").removeClass('active');
            $("#product-group-container"+$(this).val()).addClass('active');
            


            $("#product-group-container"+$(this).val()).find('.product-button').trigger('click');
            
            

        });

        $(document).on('click', '.browse-group', function() {
           var id =$(this).data('id');
           $(".browse-group").removeClass('active');
           $(this).addClass('active');
           $(".browse-group-container").removeClass('active');
           $("#browse-group-container"+id).addClass('active');
           LoadSelectedSku();
        });

        $(document).on('click', '.product-button', function() {
            var id =$(this).data('id');
            $(".product-button").removeClass('active');
            $(this).addClass('active');
            $(".product-content").removeClass('active');
            $("#product-content"+id).addClass('active');
            LoadSelectedSku();

            if($(this).data('image')){
                $('.product-image-container').hide();
                $('#product-detail-image-sku').attr("src", $(this).data('image'));
                $('#product-image-container-sku').show();
            }
            else{
                $('.product-image-container').hide();
                $('#product-image-wrap').children(":first").show()
            }
        });

        $(document).on('click', '.qtyplus', function() {
            var fieldName = $(this).attr('field');
            var qty_field = $('#'+fieldName+'');
            var currentVal = parseInt(qty_field.val());
    
            var canUpdate=true;
            if (!isNaN(currentVal)) {
                currentVal += 1;
                qty_field.val(currentVal);
            } else {
                qty_field.val(0);
                currentVal=0;
            }
        });

        $(document).on('click', '.qtyminus', function() {
            var fieldName = $(this).attr('field');
            var qty_field = $('#'+fieldName+'');
            var min = qty_field.attr('min');
            var currentVal = parseInt(qty_field.val());
    
            var canUpdate=true;
            if (!isNaN(currentVal) && currentVal > 0) {
                if(min){
                    if(currentVal > min){
                        currentVal -= 1;
                    }else{
                        currentVal = min;
                        canUpdate=false;
                    }
                }else{
                    currentVal -= 1;
                }
    
                qty_field.val(currentVal);
            } else {
                currentVal=0;
                qty_field.val(0);
            }
        });
        
        $(document).on('click', '.inline-add-to-cart', function() {
            var addButton = $(this);
            var row = addButton.parent().parent();
            var id = parseInt(row.data('secondary'));
            var qty = parseInt(row.find('.qty-input').val());
            var variation = [];

            row.find('.dropdown').each(function () {
                variation.push( $(this).val() );
            });

            if(isNaN(qty)){
                qty=1;
            }
            if(qty<1){
                return false;
            }

            if(!isNaN(id)){
                $.ajax({
                    type: 'GET',
                    url: '/shoppingcart/add/Product/'+id,
                    cache: false,
                    data: {'quantity':qty, 'variation':variation},
                    beforeSend:function(){},
                    dataType: 'json',
                }).done(function(data){
                    $('#headerCart').replaceWith(data.response);
                    setTimeout(function(){
                        $("#headerCart").toggleClass('open');
                        $('#cart-shade').fadeIn(300);
                    }, 500);
                });
            }
        });

        $(document).on('click', '#mobile-add-to-cart', function() {
            var id = 0;
            var qty = parseInt($('#MobileAddToCartQty').val());
            var variation = [];

            $(".product-group-container").each(function(){
                if($(this).hasClass("active")){
                    $(this).find('.product-button').each(function () {
                        if($(this).hasClass("active")){
                            id = $(this).data('id');
                        }
                    });
                    $('#product-content'+id).find('.color-swatch').each(function () {
                        if($(this).hasClass("active")){
                            variation.push( $(this).data('id') );
                        }
                    });
                }
            });

            
            if(isNaN(qty)){
                qty=1;
            }
            if(qty<1){
                return false;
            }

            if(!isNaN(id)){
                $.ajax({
                    type: 'GET',
                    url: '/shoppingcart/add/Product/'+id,
                    cache: false,
                    data: {'quantity':qty, 'variation':variation},
                    beforeSend:function(){
                    },
                    dataType: 'json',
                }).done(function(data){
                    $('#headerCart').replaceWith(data.response);
                
                    setTimeout(function(){
                        $("#headerCart").toggleClass('open');
                        $('#cart-shade').fadeIn(300);
                    }, 500);
                });
            }
        });

        $(document).on('click', '#main-add-to-cart', function() {
            var id = 0;
            var qty = parseInt($('#AddToCartQty').val());
            var variation = [];

            $(".product-group-container").each(function(){
                if($(this).hasClass("active")){
                    $(this).find('.product-button').each(function () {
                        if($(this).hasClass("active")){
                            id = $(this).data('id');
                        }
                    });
                    $('#product-content'+id).find('.color-swatch').each(function () {
                        if($(this).hasClass("active")){
                            variation.push( $(this).data('id') );
                        }
                    });
                }
            });

            if(isNaN(qty)){
                qty=1;
            }
            if(qty<1){
                return false;
            }

            if(!isNaN(id)){
                $.ajax({
                    type: 'GET',
                    url: '/shoppingcart/add/Product/'+id,
                    cache: false,
                    data: {'quantity':qty, 'variation':variation},
                    beforeSend:function(){
                    },
                    dataType: 'json',
                }).done(function(data){
                    $('#headerCart').replaceWith(data.response);
                
                    setTimeout(function(){
                        $("#headerCart").toggleClass('open');
                        $('#cart-shade').fadeIn(300);
                    }, 500);
                });
            }
        });

        $(document).on('click', '.color-swatch', function() {
            $(this).parent().find(".color-swatch").removeClass('active');
            $(this).addClass('active');
            LoadSelectedSku();
        });

        function LoadSelectedSku(){
            var id = 0;
            var sku = '';
            var price = '';
            var option = 'A';
            var title ='';

            $(".product-group-container").each(function(){
                if($(this).hasClass("active")){
                    $(this).find('.product-button').each(function () {
                        if($(this).hasClass("active")){
                            id = $(this).data('id');
                            sku = $(this).data('sku');
                            price = $(this).data('price');
                            option = $(this).data('option');
                        }
                    });
                    $('#product-content'+id).find('.color-swatch').each(function () {
                        if($(this).hasClass("active")){
                            sku += '-'+$(this).data('title');
                            title =$(this).data('title');
                            $('#variation-value'+$(this).data('group')+'-'+$(this).data('sku')).html($(this).data('title'));
                        }
                    });
                }
            });

            $('#product-sku').html('#'+sku);
            $('#product-price').html('$'+price);

            if(option == 'A'){
                $('#product-pricing-option').html('Save 2% when you order 11+');
            }
            else{
                $('#product-pricing-option').html('Save 2% when you order 4+');
            }

            
        }// End LoadSelectedSku

        $('.secondary-product-thumb').on('click', function() {
            var id = $(this).data('id');
            $('.product-image-container').hide();
            $('#product-image-container'+id).show();
            return false;
        });

    }//end ProductPage

    if($('.CartPage').length > 0) {

        $(document).on('click', '.remove-from-cart', function() {
            var id = $(this).data('id');
            
            if(!isNaN(id)){
                $.ajax({
                    type: 'GET',
                    url: '/shoppingcart/remove/',
                    cache: false,
                    data: {'id':id},
                    beforeSend:function(){
                        
                    },
                    dataType: 'json',
                }).done(function(data){
                    window.location = '/cart/';
                });
            }
        });

        $(document).on('click', '.qtyplus', function() {
            var fieldName = $(this).attr('field');
            var qty_field = $('input[name="'+fieldName+'"]');
            var currentVal = parseInt(qty_field.val());

            if (!isNaN(currentVal)) {
                currentVal += 1;
                qty_field.val(currentVal);
            } else {
                qty_field.val(0);
                currentVal=0;
            }

            var id = $(this).data('id');
            if(!isNaN(id)){
                $.ajax({
                    type: 'GET',
                    url: '/shoppingcart/setquantity/',
                    cache: false,
                    data: {'id':id, 'qty':currentVal},
                    beforeSend:function(){
                        
                    },
                    dataType: 'json',
                }).done(function(data){
                    UpdateCart();
                });
            }

        });

        $(document).on('click', '.qtyminus', function() {
            var fieldName = $(this).attr('field');
            var qty_field = $('input[name="'+fieldName+'"]');
            var min = qty_field.attr('min');
            var currentVal = parseInt(qty_field.val());

            var canUpdate=true;
            if (!isNaN(currentVal) && currentVal > 0) {
                if(min){
                    if(currentVal > min){
                        currentVal -= 1;
                    }else{
                        currentVal = min;
                        canUpdate=false;
                    }
                }else{
                    currentVal -= 1;
                }

                qty_field.val(currentVal);
            } else {
                currentVal=0;
                qty_field.val(0);
            }

            var id = $(this).data('id');
            if(!isNaN(id)){
                $.ajax({
                    type: 'GET',
                    url: '/shoppingcart/setquantity/',
                    cache: false,
                    data: {'id':id, 'qty':currentVal},
                    beforeSend:function(){
                        
                    },
                    dataType: 'json',
                }).done(function(data){
                    UpdateCart();
                });
            }
        });

        $(document).on('click', '.add-promo-code', function() {
            $('.promo-container').removeClass('open');
            $('.promo-container').addClass('open');
            $('html, body').animate({ scrollTop: 250 }, 500);
        });

        $(document).on('click', '#cancel-promo', function() {
            $('.promo-container').removeClass('open');
            $('html, body').animate({ scrollTop: -250 }, 500);
        });

        $(document).on('click', '#delete-promo-code', function(e) {
            $.ajax({
                type: 'POST',
                url: '/api/form/delpromo/',
                cache: false,
                data: {'c':'del'},
                dataType: 'json',
            })
            .done(function(data){
                UpdateCart();
                $('.promo-container').removeClass('open');
                $('html, body').animate({ scrollTop: -250 }, 500);
            });
        });

        $(document).on('click', '#apply-promo-code', function(e) {
            var code = $('#promo-code').val();
            
            $('#promo-code-error').hide();

            if(code){
                $.ajax({
                    type: 'POST',
                    url: '/api/form/promo/',
                    cache: false,
                    data: {'c':code},
                    dataType: 'json',
                })
                .done(function(data){
                    if(data.error){
                        console.log(data.msg);
                        $('#promo-code-error').show();
                    }
                    else{
                        UpdateCart();
                        $('.promo-container').removeClass('open');
                        $('html, body').animate({ scrollTop: -250 }, 500);
                    }
                });
            }
        });
        
    }//end CartPage

    if($('.HomePage').length > 0) {

        let rotateReviews = 0;
        $(document).ready(function() {
            const intervalRSE = setInterval(function() {
                $('.rating-item').removeClass('active');
                rotateReviews += 1;
                if($('#rating-item'+rotateReviews).length > 0) {
                    $('#rating-item'+rotateReviews).addClass('active');
                }
                else{
                    rotateReviews = 1;
                    $('#rating-item'+rotateReviews).addClass('active');
                }
            }, 7000); 
        });

    }//end HomePage

    if($('.SignInPage').length > 0) {

        document.getElementById("MemberLoginForm_MemberLoginForm_Email").setAttribute("placeholder", "Email");
        document.getElementById("MemberLoginForm_MemberLoginForm_Password").setAttribute("placeholder", "Password");

    }//end SignInPage
    
    if($('.AccountPage').length > 0) {

        $(document).on('click', '.add-new-address', function() {
            $(".add-address").toggleClass('active');
        });

        if($('#ChangePasswordForm_ChangePasswordForm_OldPassword').length > 0) {
            document.getElementById("ChangePasswordForm_ChangePasswordForm_OldPassword").setAttribute("placeholder", "Old Password");
            document.getElementById("ChangePasswordForm_ChangePasswordForm_NewPassword1").setAttribute("placeholder", "New Password");
            document.getElementById("ChangePasswordForm_ChangePasswordForm_NewPassword2").setAttribute("placeholder", "Confirm New Password");
        }

        $(document).on('click', '#claim-quote', function() {
            $("#redeemerror").hide();
                var ref=$("#claim-quote").data('id');
                ref=ref.toUpperCase();
              
                // const regex = /^Q\d+$/;
                // if (regex.test(ref)) {
                    $.ajax({
                        type: 'POST',
                        url: '/api/form/claimquote/',
                        cache: false,
                        data: {"ref": ref},
                        dataType: 'json',
                    })
                    .done(function(data){
                        if(data.error){
                            $("#redeemerror").html(data.msg+"<br><br>'");
                            $("#redeemerror").show();
                        }
                        else{
                            window.location = '/checkout/';
                        }
                    });
                // } else {
                //     $("#redeemerror").html('Quote # should be in the format Q######.<br><br>');
                //     $("#redeemerror").show();
                // }
        });
    }//end AccountPage

    if($('.RequestQuote').length > 0) {

        $(document).ready(function() {
            loadOrderEmails();
        });
        
        $(document).on('click', '.add-contact', function() {
            $("#CustomerInformationForm_SecondEmail_Holder").toggleClass('active');
        });
        
        $(document).on('submit', '#CustomerInformationForm', function(e) {
            e.preventDefault();
            var self = $(this);
            if(validateQuoteInput()){
                $.ajax({
                    type: 'POST',
                    url: '/api/form/cif/',
                    cache: false,
                    data: self.serialize(),
                    dataType: 'json',
                })
                .done(function(data){
                    $("#shipping-information-label").trigger('click');
                });

                $('#customer-information-inactive').html($('#CustomerInformationForm_FirstName').val()+" "+$('#CustomerInformationForm_Surname').val());

                var customerReference=""
                if($('#CustomerInformationForm_CustomerQuoteReference').val()){
                    customerReference="Customer Reference: " + $('#CustomerInformationForm_CustomerQuoteReference').val();
                }

                $('#CustomerQuoteReference').html(customerReference);
            }
        });
        
        $(document).on('change', '#ShippingInformationForm_ShippingBillingSame', function(e){
            if($(this).is(':checked')){
                $("#BillingInformation_Form").hide();
            }
            else{
                $("#BillingInformation_Form").show();
            }
        });

        $(document).on('submit', '#ShippingInformationForm', function(e) {
            e.preventDefault();
            var self = $(this);
            if(validateQuoteInput()){
                $.ajax({
                    type: 'POST',
                    url: '/api/form/sif/',
                    cache: false,
                    data: self.serialize(),
                    dataType: 'json',
                })
                .done(function(data){
                    $("#shipping-options-label").trigger('click');
                });

                $('#shipping-information-inactive').html(
                    $('#ShippingInformationForm_ShippingAddress').val()+'<br>'+
                    $('#ShippingInformationForm_ShippingCity').val()+', '+
                    $('#ShippingInformationForm_ShippingState').val()+' '+
                    $('#ShippingInformationForm_ShippingPostalCode').val()
                );
            }
        });

        $(document).on('submit', '#ShippingOptionsForm', function(e) {
            e.preventDefault();
            var self = $(this);
            if(validateQuoteInput()){
                $.ajax({
                    type: 'POST',
                    url: '/api/form/sof/',
                    cache: false,
                    data: self.serialize(),
                    dataType: 'json',
                })
                .done(function(data){
                    $("#additional-info-label").trigger('click');
                });
            }
            
        });
        
        $(document).on('submit', '#AdditionalInformationForm', function(e) {
            e.preventDefault();

            if(validateQuoteInput()){
                var self = $(this);

                var customerReference=""
                if($('#CustomerInformationForm_CustomerQuoteReference').val()){
                    customerReference="Customer Reference: " + $('#CustomerInformationForm_CustomerQuoteReference').val();
                }
                $('#CustomerQuoteReference').html(customerReference);

                $.ajax({ type: 'POST', url: '/api/form/cif/', cache: false, data: $("#CustomerInformationForm").serialize(), dataType: 'json' });
                $.ajax({ type: 'POST', url: '/api/form/sif/', cache: false, data: $("#ShippingInformationForm").serialize(), dataType: 'json' });
                $.ajax({ type: 'POST', url: '/api/form/sof/', cache: false, data: $("#ShippingOptionsForm").serialize(), dataType: 'json' });
                $.ajax({
                    type: 'POST',
                    url: '/api/form/aif/',
                    cache: false,
                    data: self.serialize(),
                    dataType: 'json',
                })
                .done(function(data){
                    $("#quote").hide();
                    $("#confirmation").show();
                    $('html, body').animate({ scrollTop: 0 }, 500);
                });
            }

        });

        $(document).on('click', '.qtyplus', function() {
            var fieldName = $(this).attr('field');
            var qty_field = $('input[name="'+fieldName+'"]');
            var currentVal = parseInt(qty_field.val());

            if (!isNaN(currentVal)) {
                currentVal += 1;
                qty_field.val(currentVal);
            } else {
                qty_field.val(0);
                currentVal=0;
            }

            var id = $(this).data('id');
            if(!isNaN(id)){
                $.ajax({
                    type: 'GET',
                    url: '/shoppingcart/setquantity/',
                    cache: false,
                    data: {'id':id, 'qty':currentVal},
                    beforeSend:function(){
                        
                    },
                    dataType: 'json',
                }).done(function(data){
                    UpdateCart();
                });
            }

        });

        $(document).on('click', '.qtyminus', function() {
            var fieldName = $(this).attr('field');
            var qty_field = $('input[name="'+fieldName+'"]');
            var min = qty_field.attr('min');
            var currentVal = parseInt(qty_field.val());

            var canUpdate=true;
            if (!isNaN(currentVal) && currentVal > 0) {
                if(min){
                    if(currentVal > min){
                        currentVal -= 1;
                    }else{
                        currentVal = min;
                        canUpdate=false;
                    }
                }else{
                    currentVal -= 1;
                }

                qty_field.val(currentVal);
            } else {
                currentVal=0;
                qty_field.val(0);
            }

            var id = $(this).data('id');
            if(!isNaN(id)){
                $.ajax({
                    type: 'GET',
                    url: '/shoppingcart/setquantity/',
                    cache: false,
                    data: {'id':id, 'qty':currentVal},
                    beforeSend:function(){
                        
                    },
                    dataType: 'json',
                }).done(function(data){
                    UpdateCart();
                });
            }
        });

        $(document).on('down.zf.accordion', function(event, $element) {
            validateQuoteInput();
        });

        function validateQuoteInput(){
            var foundError = false;
            var errorMessage = '';

            switch ($(".is-active").attr('id')) {
                case 'customer-information':

                    break;
                case 'shipping-information':
                    $("#CustomerInformationForm_error").hide();
                    
                    if (!$("#CustomerInformationForm_FirstName").val()) {
                        errorMessage += 'Missing First Name<br>';
                    }
                    if (!$("#CustomerInformationForm_Surname").val()) {
                        errorMessage += 'Missing Last Name<br>';
                    }
                    if (!$("#CustomerInformationForm_Email").val()) {
                        errorMessage += 'Missing Email Address<br>';
                    }
                    if(errorMessage){
                        $("#CustomerInformationForm_error").html(errorMessage);
                        $("#CustomerInformationForm_error").show();
                        $("#customer-information-label").trigger('click');
                        return false;
                    }
                    break;
                case 'shipping-options':
                case 'additional-info':
                    $("#CustomerInformationForm_error").hide();
                    
                    if (!$("#CustomerInformationForm_FirstName").val()) {
                        errorMessage += 'Missing First Name<br>';
                    }
                    if (!$("#CustomerInformationForm_Surname").val()) {
                        errorMessage += 'Missing Last Name<br>';
                    }
                    if (!$("#CustomerInformationForm_Email").val()) {
                        errorMessage += 'Missing Email Address<br>';
                    }
                    if(errorMessage){
                        $("#CustomerInformationForm_error").html(errorMessage);
                        $("#CustomerInformationForm_error").show();
                        $("#customer-information-label").trigger('click');
                        return false;
                    }


                    $("#ShippingInformationForm_error").hide();
                    if (!$("#ShippingInformationForm_ShippingAddress").val()) {
                        errorMessage += 'Missing Shipping Address<br>';
                    }
                    if (!$("#ShippingInformationForm_ShippingCity").val()) {
                        errorMessage += 'Missing Shipping City<br>';
                    }
                    if (!$("#ShippingInformationForm_ShippingState").val()) {
                        errorMessage += 'Missing Shipping State<br>';
                    }
                    if (!$("#ShippingInformationForm_ShippingPostalCode").val()) {
                        errorMessage += 'Missing Shipping Zip<br>';
                    }
                    
                    if(errorMessage){
                        $("#ShippingInformationForm_error").html(errorMessage);
                        $("#ShippingInformationForm_error").show();
                        $("#shipping-information-label").trigger('click');
                        return false;
                    }
                break;
            }

            return true;
        }//End validateQuoteInput


        $(document).on('click', '#add-order-email-btn', function() {
            $.ajax({ 
                type: 'POST', 
                url: '/api/form/addemail/', 
                cache: false, 
                data: {'SecondEmail':$("#CustomerInformationForm_SecondEmail").val()}, 
                dataType: 'json' })
            .done(function(data){
                if(data.error){
                    console.log(data.msg);
                }
                else{
                    $("#CustomerInformationForm_SecondEmail").val('')
                    loadOrderEmails();
                }
            });
        });

        $(document).on('click', '.delete-additional-email', function() {
            var id = $(this).data('id');
            $.ajax({ 
                type: 'POST', 
                url: '/api/form/deleteemail/', 
                cache: false, 
                data: {'emailid':id}, 
                dataType: 'json' })
            .done(function(data){
                if(data.error){
                    console.log(data.msg);
                }
                else{
                    loadOrderEmails();
                }
            });
        });
        
        function loadOrderEmails(){
            $.ajax({
				type: "GET",
				url: '/api/form/viewemail/',
				dataType: 'json',
				cache: false,
				data: {},
			})
			.done(function (data) {
				$("#additional-order-emails").html(data.output);
			})
			.fail (function (xhr) {
				//window.location.replace(".");
			});
        }

    }//end RequestQuote

    if($('.CheckoutPage').length > 0) {
        
        $(document).ready(function() {
            loadOrderEmails();
        });

        $(document).on('click', '.add-contact', function() {
            $("#CheckoutContactInformationForm_SecondEmail_Holder").toggleClass('active');
        });
        
        $(document).on('submit', '#CheckoutContactInformationForm', function(e) {
            e.preventDefault();
            var self = $(this);

            if(validateInput()){
                $("#create-account-error").hide();

                console.log(self.serialize());
    
                $.ajax({
                    type: 'POST',
                    url: '/api/form/ccif/',
                    cache: false,
                    data: self.serialize(),
                    dataType: 'json',
                })
                .done(function(data){
                    if(data.error){
                        console.log(data.msg);
                        if(data.msg=='MEMBER_EXISTS'){
                            $("#create-account-error").show();
                            $("#create-account-error").html('Member email exists.');
                        }
                    }
                    else{
                        $("#shipping-information-label").trigger('click');
                    }
                });
    
                $('#customer-information-inactive').html($('#CheckoutContactInformationForm_Email').val());
            }
            
        });
        
        $(document).on('submit', '#CheckoutShippingInformationForm', function(e) {
            e.preventDefault();
            var self = $(this);
            if(validateInput()){
                $.ajax({
                    type: 'POST',
                    url: '/api/form/csif/',
                    cache: false,
                    data: self.serialize(),
                    dataType: 'json',
                })
                .done(function(data){
                    $("#shipping-options-label").trigger('click');
                });

                $('#shipping-information-inactive').html(
                    $('#CheckoutShippingInformationForm_ShippingAddress').val()+'<br>'+
                    $('#CheckoutShippingInformationForm_ShippingCity').val()+', '+
                    $('#CheckoutShippingInformationForm_ShippingState').val()+' '+
                    $('#CheckoutShippingInformationForm_ShippingPostalCode').val()
                );
            }
        });

        $(document).on('submit', '#CheckoutShippingInformationReadOnlyForm', function(e) {
            e.preventDefault();
               
            $("#shipping-options-label").trigger('click');
            $('#shipping-information-inactive').html(
                $('#CheckoutShippingInformationReadOnlyForm_ShippingAddress').val()+'<br>'+
                $('#CheckoutShippingInformationReadOnlyForm_ShippingCity').val()+', '+
                $('#CheckoutShippingInformationReadOnlyForm_ShippingState').val()+' '+
                $('#CheckoutShippingInformationReadOnlyForm_ShippingPostalCode').val()
            );
        });

        $(document).on('submit', '#CheckoutPaymentInformationForm', function(e) {
            e.preventDefault();
            // $("#shipping-options-label").trigger('click');
        });

        $(document).on('submit', '#ShippingOptionsForm', function(e) {
            e.preventDefault();
            var self = $(this);

            console.log(self.serialize());

            $.ajax({
                type: 'POST',
                url: '/api/form/sof/',
                cache: false,
                data: self.serialize(),
                dataType: 'json',
            })
            .done(function(data){
                $("#payment-info-label").trigger('click');
                loadCheckoutDetails();
            });
            
        });
               
        $(document).on('click', '#CheckoutPaymentInformationForm_PaymentCreditCard', function() {
            $('#CheckoutPaymentInformationForm_PaymentNetFifteen').prop('checked', false);
            $('#CheckoutPaymentInformationForm_PaymentCreditCard').prop('checked', true);
            $('#credit-card-payment').show();
            $('#net-fifteen-payment').hide();
        });

        $(document).on('click', '#CheckoutPaymentInformationForm_PaymentNetFifteen', function() {
            $('#CheckoutPaymentInformationForm_PaymentNetFifteen').prop('checked', true);
            $('#CheckoutPaymentInformationForm_PaymentCreditCard').prop('checked', false);
            $('#credit-card-payment').hide();
            $('#net-fifteen-payment').show();
        });

        $(document).on('change', '#CheckoutPaymentInformationForm_ShippingBillingSame', function(e){
            if($(this).is(':checked')){
                $("#BillingInformation_Form").hide();
            }
            else{
                $("#BillingInformation_Form").show();
            }
        });

        function validateInput(){
            var foundError = false;
            var errorMessage = '';

            switch ($(".is-active").attr('id')) {
                case 'customer-information':
                    break;
                case 'shipping-information':
                    
                    $("#CheckoutContactInformationForm_error").hide();
                    
                    if (!$("#CheckoutContactInformationForm_FirstName").val()) {
                        errorMessage += 'Missing First Name<br>';
                    }
                    if (!$("#CheckoutContactInformationForm_Surname").val()) {
                        errorMessage += 'Missing Last Name<br>';
                    }
                    if (!$("#CheckoutContactInformationForm_Email").val()) {
                        errorMessage += 'Missing Email<br>';
                    }
                    if(errorMessage){
                        $("#CheckoutContactInformationForm_error").html(errorMessage);
                        $("#CheckoutContactInformationForm_error").show();
                        $("#customer-information-label").trigger('click');
                        return false;
                    }

                    break;
                case 'shipping-options':
                case 'payment-info':
                    
                    $("#CheckoutContactInformationForm_error").hide();
                    
                    if (!$("#CheckoutContactInformationForm_FirstName").val()) {
                        errorMessage += 'Missing First Name<br>';
                    }
                    if (!$("#CheckoutContactInformationForm_Surname").val()) {
                        errorMessage += 'Missing Last Name<br>';
                    }
                    if (!$("#CheckoutContactInformationForm_Email").val()) {
                        errorMessage += 'Missing Email<br>';
                    }
                    if(errorMessage){
                        $("#CheckoutContactInformationForm_error").html(errorMessage);
                        $("#CheckoutContactInformationForm_error").show();
                        $("#customer-information-label").trigger('click');
                        return false;
                    }
                    

                    if($('#CheckoutShippingInformationReadOnlyForm').length > 0) {
                        break;
                    }
                    $("#CheckoutShippingInformationForm_error").hide();
                    if (!$("#CheckoutShippingInformationForm_ShippingAddress").val()) {
                        errorMessage += 'Missing Address<br>';
                    }
                    if (!$("#CheckoutShippingInformationForm_ShippingCity").val()) {
                        errorMessage += 'Missing City<br>';
                    }
                    if (!$("#CheckoutShippingInformationForm_ShippingState").val()) {
                        errorMessage += 'Missing State<br>';
                    }
                    if (!$("#CheckoutShippingInformationForm_ShippingPostalCode").val()) {
                        errorMessage += 'Missing Zip<br>';
                    }
                    if(errorMessage){
                        $("#CheckoutShippingInformationForm_error").html(errorMessage);
                        $("#CheckoutShippingInformationForm_error").show();
                        $("#shipping-information-label").trigger('click');
                        return false;
                    }
                break;
            }

            return true;
        }//End validateInput

        $(document).on('click', '#shipping-information-label', function() {
            if(validateInput()){
                $.ajax({ type: 'POST', url: '/api/form/ccif/', cache: false, data: $("#CheckoutContactInformationForm").serialize(), dataType: 'json' });
                loadCheckoutDetails();
            }
        });

        $(document).on('click', '#add-order-email-btn', function() {
            $.ajax({ 
                type: 'POST', 
                url: '/api/form/addemail/', 
                cache: false, 
                data: {'SecondEmail':$("#CheckoutContactInformationForm_SecondEmail").val()}, 
                dataType: 'json' })
            .done(function(data){
                if(data.error){
                    console.log(data.msg);
                }
                else{
                    $("#CheckoutContactInformationForm_SecondEmail").val('')
                    loadOrderEmails();
                }
            });
        });

        $(document).on('click', '.delete-additional-email', function() {
            var id = $(this).data('id');
            $.ajax({ 
                type: 'POST', 
                url: '/api/form/deleteemail/', 
                cache: false, 
                data: {'emailid':id}, 
                dataType: 'json' })
            .done(function(data){
                if(data.error){
                    console.log(data.msg);
                }
                else{
                    loadOrderEmails();
                }
            });
        });
        
        function loadOrderEmails(){
            $.ajax({
				type: "GET",
				url: '/api/form/viewemail/',
				dataType: 'json',
				cache: false,
				data: {},
			})
			.done(function (data) {
				$("#additional-order-emails").html(data.output);
			})
			.fail (function (xhr) {
				//window.location.replace(".");
			});
        }

        $(document).on('click', '#shipping-options-label', function() {
            if(validateInput()){
                $.ajax({ type: 'POST', url: '/api/form/ccif/', cache: false, data: $("#CheckoutContactInformationForm").serialize(), dataType: 'json' });
                if($('#CheckoutShippingInformationForme').length > 0) {
                    $.ajax({ type: 'POST', url: '/api/form/csif/', cache: false, data: $("#CheckoutShippingInformationForm").serialize(), dataType: 'json' });
                }
                loadCheckoutDetails();
            }
        });
        
        $(document).on('click', '#payment-info-label', function() {
            if(validateInput()){
                $.ajax({ type: 'POST', url: '/api/form/ccif/', cache: false, data: $("#CheckoutContactInformationForm").serialize(), dataType: 'json' });
                if($('#CheckoutShippingInformationForme').length > 0) {
                    $.ajax({ type: 'POST', url: '/api/form/csif/', cache: false, data: $("#CheckoutShippingInformationForm").serialize(), dataType: 'json' });
                }
                $.ajax({ type: 'POST', url: '/api/form/sof/', cache: false, data: $("#ShippingOptionsForm").serialize(), dataType: 'json' });
                loadCheckoutDetails();
            }
        });

        $(document).on('click', '.add-promo-code', function() {
            $('.promo-container').removeClass('open');
            $('.promo-container').addClass('open');
            $('html, body').animate({ scrollTop: 250 }, 500);
        });

        $(document).on('click', '#cancel-promo', function() {
            $('.promo-container').removeClass('open');
            $('html, body').animate({ scrollTop: -250 }, 500);
        });

        $(document).on('click', '#delete-promo-code', function(e) {
            $.ajax({
                type: 'POST',
                url: '/api/form/delpromo/',
                cache: false,
                data: {'c':'del'},
                dataType: 'json',
            })
            .done(function(data){
                if(data.error){
                    console.log(data.msg);
                    $('#promo-code-error').show();
                }
                else{
                    loadCheckoutDetails();
                    $('.promo-container').removeClass('open');
                    $('html, body').animate({ scrollTop: -250 }, 500);
                }
            });
        });

        $(document).on('click', '#apply-promo-code', function(e) {
            var code = $('#promo-code').val();
            if(code){
                $.ajax({
                    type: 'POST',
                    url: '/api/form/promo/',
                    cache: false,
                    data: {'c':code},
                    dataType: 'json',
                })
                .done(function(data){
                    if(data.error){
                        console.log(data.msg);
                        $('#promo-code-error').show();
                    }
                    else{
                        loadCheckoutDetails();
                        $('.promo-container').removeClass('open');
                        $('html, body').animate({ scrollTop: -250 }, 500);
                    }
                });
            }
        });

        function loadCheckoutDetails(){
            var orderid = $('#orderid').data('id');

            $.ajax({
				type: "GET",
				url: '/s/checkoutdetails/?q='+orderid,
				dataType: 'json',
				cache: false,
				data: {},
			})
			.done(function (data) {
				$("#checkout-side-cart").html(data.output);
			})
			.fail (function (xhr) {
				//window.location.replace(".");
			});
        }

    }//end CheckoutPage

    if($('.ViewQuotePage').length > 0) {

        $(document).on('click', '#claim-quote', function() {
            $("#redeemerror").hide();

           
                var ref=$("#claim-quote").data('id');
                ref=ref.toUpperCase();
              
                // const regex = /^Q\d+$/;
                // if (regex.test(ref)) {
                    $.ajax({
                        type: 'POST',
                        url: '/api/form/claimquote/',
                        cache: false,
                        data: {"ref": ref},
                        dataType: 'json',
                    })
                    .done(function(data){
                        if(data.error){
                            $("#redeemerror").html(data.msg+"<br><br>'");
                            $("#redeemerror").show();
                        }
                        else{
                            window.location = '/checkout/';
                        }
                    });
                // } else {
                //     $("#redeemerror").html('Quote # should be in the format Q######.<br><br>');
                //     $("#redeemerror").show();
                // }
        });
    }//end CheckoutPage

    if($('.CMSEditOrder').length > 0) {
        $(document).ready(function() {
            loadOrderDetails();
        });
        
        $(document).on('click', '.qtyplus', function() {
            var fieldName = $(this).attr('field');
            var qty_field = $('#'+fieldName+'');
            var currentVal = parseInt(qty_field.val());
    
            var canUpdate=true;
            if (!isNaN(currentVal)) {
                currentVal += 1;
                qty_field.val(currentVal);
            } else {
                qty_field.val(0);
                currentVal=0;
            }
        });

        $(document).on('click', '.qtyminus', function() {
            var fieldName = $(this).attr('field');
            var qty_field = $('#'+fieldName+'');
            var min = qty_field.attr('min');
            var currentVal = parseInt(qty_field.val());
    
            var canUpdate=true;
            if (!isNaN(currentVal) && currentVal > 0) {
                if(min){
                    if(currentVal > min){
                        currentVal -= 1;
                    }else{
                        currentVal = min;
                        canUpdate=false;
                    }
                }else{
                    currentVal -= 1;
                }
    
                qty_field.val(currentVal);
            } else {
                currentVal=0;
                qty_field.val(0);
            }
        });
        
        $(document).on('click', '.inline-add-to-cart', function() {
            var addButton = $(this);
            var row = addButton.parent().parent();
            var id = parseInt(row.data('secondary'));
            var qty = parseInt(row.find('.qty-input').val());
            var variation = [];
            var orderid = $('#orderid').data('id');

            row.find('.dropdown').each(function () {
                variation.push( $(this).val() );
            });
            if(isNaN(qty)){
                qty=1;
            }
            if(qty<1){
                return false;
            }

            if(!isNaN(id)){
                $.ajax({
                    type: 'GET',
                    url: '/shoppingcart/addcms/Product/'+id,
                    cache: false,
                    data: {'orderid':orderid,'quantity':qty, 'variation':variation},
                    beforeSend:function(){},
                    dataType: 'json',
                }).done(function(data){
                    loadOrderDetails();
                });
            }
        });


        function loadOrderDetails(){
            var orderid = $('#orderid').data('id');

            $.ajax({
				type: "GET",
				url: '/s/orderdetails/?q='+orderid,
				dataType: 'json',
				cache: false,
				data: {},
			})
			.done(function (data) {
				$("#order-details").html(data.output);
			})
			.fail (function (xhr) {
				//window.location.replace(".");
			});
        }

        var cmsTimer = null;

		$(document).on('submit', '#ProductSearchForm', function(e) {
        	e.preventDefault();
		});
		
		$('#ProductSearchForm_q').attr('autocomplete', 'off');

		$(document).on('keydown keypress keyup', '#ProductSearchForm_q', function(e){
			if (cmsTimer) {
				clearTimeout(cmsTimer);
			}
			var self = $(this);
			var value = self.val().toLowerCase();
		
			if(value.length < 3){
				$('#product-results').remove();
				return;
			}
		
			var code = (e.keyCode ? e.keyCode : e.which);
			if (code == 40 || code == 38 || code == 13 || code == 17 || code == 18 || code == 91) return;
		
			var top = self.offset().top + 50;
			var left = self.offset().left;
			var holder = $('#product-results');
		
			if(holder.length < 1){
				holder = $('<div id="product-results" class="product-search"/>').css({}).appendTo($('#product-search-container')).html('Loading...');
			}
		
		
			cmsTimer = setTimeout(function() {
				$.ajax({
					type: "GET",
					url: '/s/product/?q='+value,
					dataType: 'json',
					cache: false,
					data: {},
				})
				.done(function (data) {
					holder.html(data.output);
				})
				.fail (function (xhr) {
					//window.location.replace(".");
				});
			}, 200);
		});
		

		$(document).on('click', '.product', function(e){
			var value = $(this).data("id");

			$('#search-results').remove();

			var holder = $('#product-results');
			if(holder.length < 1){
				holder = $('<div id="product-results" class="product-search"/>').css({}).appendTo($('#product-search-container')).html('Loading...');
			}


			$.ajax({
				type: "GET",
				url: '/s/productsku/?q='+value,
				dataType: 'json',
				cache: false,
				data: {},
			})
			.done(function (data) {
				holder.html(data.output);
			})
			.fail (function (xhr) {
				//window.location.replace(".");
			});

		});

    }//end CMSEditOrder


    if($('.CMSUploadProductPage').length > 0) {

        $(document).ready(function() {
            if ($('#product-search-container').data('id')) {
                var productId = $('#product-search-container').data('id');
                var holder = $('#product-results');
                if(holder.length < 1){
                    holder = $('<div id="product-results" class="product-search"/>').css({}).appendTo($('#product-search-container')).html('Loading...');
                }

                $.ajax({
                    type: "GET",
                    url: '/s/importproduct/?q='+productId,
                    dataType: 'json',
                    cache: false,
                    data: {},
                })
                .done(function (data) {
                    holder.html(data.output);
                })
                .fail (function (xhr) {
                    //window.location.replace(".");
                });
            }
        });

        var cmsTimer = null;

		$(document).on('submit', '#ProductSearchForm', function(e) {
        	e.preventDefault();
		});
		
		$('#ProductSearchForm_q').attr('autocomplete', 'off');

		$(document).on('keydown keypress keyup', '#ProductSearchForm_q', function(e){
			if (cmsTimer) {
				clearTimeout(cmsTimer);
			}
			var self = $(this);
			var value = self.val().toLowerCase();
		
			if(value.length < 3){
				$('#product-results').remove();
				return;
			}
		
			var code = (e.keyCode ? e.keyCode : e.which);
			if (code == 40 || code == 38 || code == 13 || code == 17 || code == 18 || code == 91) return;
		
			var top = self.offset().top + 50;
			var left = self.offset().left;
			var holder = $('#product-results');
		
			if(holder.length < 1){
				holder = $('<div id="product-results" class="product-search"/>').css({}).appendTo($('#product-search-container')).html('Loading...');
			}
		
		
			cmsTimer = setTimeout(function() {
				$.ajax({
					type: "GET",
					url: '/s/product/?q='+value,
					dataType: 'json',
					cache: false,
					data: {},
				})
				.done(function (data) {
					holder.html(data.output);
				})
				.fail (function (xhr) {
					//window.location.replace(".");
				});
			}, 200);
		});
		
		$(document).on('click', '.product', function(e){
			var value = $(this).data("id");

			$('#search-results').remove();

			var holder = $('#product-results');
			if(holder.length < 1){
				holder = $('<div id="product-results" class="product-search"/>').css({}).appendTo($('#product-search-container')).html('Loading...');
			}


			$.ajax({
				type: "GET",
				url: '/s/importproduct/?q='+value,
				dataType: 'json',
				cache: false,
				data: {},
			})
			.done(function (data) {
				holder.html(data.output);
			})
			.fail (function (xhr) {
				//window.location.replace(".");
			});

		});

    }//end CMSUploadProductPage

    //---------------------------------------------------------
    //  Forms
    //---------------------------------------------------------

    $(document).on('change', '#ShippingOptionsForm_FreightCollect', function(e){
        if($(this).is(':checked')){
            $("#ShippingOptionsForm_FreightCarrier_Holder").addClass('active');
            $("#ShippingOptionsForm_FreightAccountNumber_Holder").addClass('active');
        }
        else{
            $("#ShippingOptionsForm_FreightCarrier_Holder").removeClass('active');
            $("#ShippingOptionsForm_FreightAccountNumber_Holder").removeClass('active');
        }
    });

    //---------------------------------------------------------
    //  Search
    //---------------------------------------------------------
    
    

    $(document).on('change', '#cart-email-ref', function(e) {

        
        $.ajax({type: "POST", url: "/shoppingcart/setemail/", dataType: 'json', data: {"email":$(this).val()} });
        loadStandards($(this).val());
        loadValues($(this).val());
        updateWizardLinks($(this).val());
    });

    
    $(document).on('submit', '#ShopSearchForm_SearchForm', function(e){
        var value = $('#ShopSearchForm_SearchForm_q').val().toLowerCase();
        if(value.length < 1){
            return false;
        }
        window.location = '/search/?q='+value;
        return false;
    });

    $(document).on('submit', '#MobileShopSearchForm_SearchForm', function(e){
        var value = $('#MobileShopSearchForm_SearchForm_q').val().toLowerCase();
        if(value.length < 1){
            return false;
        }
        window.location = '/search/?q='+value;
        return false;
    });
    
    var myTimer = null;
    
    $('#ShopSearchForm_SearchForm_q').attr('autocomplete', 'off');
    $('#MobileShopSearchForm_SearchForm_q').attr('autocomplete', 'off');
    
    $(document).on('keydown keypress keyup', '#ShopSearchForm_SearchForm_q, #MobileShopSearchForm_SearchForm_q', function(e){
        if (myTimer) {
            clearTimeout(myTimer);
        }
        var self = $(this);
        var value = self.val().toLowerCase()
    
        if(value.length < 3){
            $('#search-results').remove();
            return;
        }
    
        var code = (e.keyCode ? e.keyCode : e.which);
        if (code == 40 || code == 38 || code == 13 || code == 17 || code == 18 || code == 91) return;
    
        var top = self.offset().top + 50;
        var left = self.offset().left;
        var holder = $('#search-results');
    
        if(holder.length < 1){
            holder = $('<div id="search-results" class="shop-search"/>').css({padding: 15, top: top, left: left}).appendTo($('body')).html('Loading...');
        }
    
        myTimer = setTimeout(function() {
    
            $.ajax({
                type: "GET",
                url: '/s/?q='+value,
                dataType: 'json',
                cache: false,
                data: {},
            })
            .done(function (data) {
                holder.html(data.output);
            })
            .fail (function (xhr) {
                 //window.location.replace(".");
            });
    
    
        }, 200);
    });
    
    $(window).click(function() {
      $('#search-results').remove();
    });
    
    $(document).on('click', '#search-results', function(e){
      e.stopPropagation();
    });
    
    var results_holder = $('#search-results-holder');
    
    if(results_holder.length > 0){
    
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const q = urlParams.get('q');
    
        $('#search_query').val(q);
    
        $.ajax({
            type: "GET",
            url: '/s/full/?q='+q,
            dataType: 'json',
            cache: false,
            data: {},
        })
        .done(function (data) {
            results_holder.html(data.output);
        })
        .fail (function (xhr) {
        });
    
        $(document).on('click', '.load-more-search-results', function(e){
            e.preventDefault();
    
            var load_more_holder = $('#load-more-holder');
    
            var self = $(this),
                link = self.attr('href');
    
    
            $.ajax({
                type: "GET",
                url: link,
                dataType: 'json',
                cache: false,
                data: {},
            })
            .done(function (data) {
                load_more_holder.replaceWith(data.output);
            })
            .fail (function (xhr) {
            });
    
        });
    
    }
    
    $(document).on('click', '#btn-redeem-quote', function() {
        $("#redeem-error").hide();

        if (!$("#redeem-quote-ref").val()) {
            $("#redeem-error").html('Quote # required.');
            $("#redeem-error").show();
        }
        else{
            var ref=$("#redeem-quote-ref").val();
            ref=ref.toUpperCase();

            // const regex = /^Q\d+$/;
            // if (regex.test(ref)) {
                $.ajax({
                    type: 'POST',
                    url: '/api/form/claimquote/',
                    cache: false,
                    data: {"ref": ref},
                    dataType: 'json',
                })
                .done(function(data){
                    if(data.error){
                        $("#redeem-error").html(data.msg);
                        $("#redeem-error").show();
                    }
                    else{
                        window.location = '/checkout/';
                    }
                });
            // } else {
            //     $("#redeem-error").html('Quote # should be in the format Q######.');
            //     $("#redeem-error").show();
            // }
        }
    });

    $(document).on('click', '#cart-btn-redeem-quote', function() {
        $("#cart-redeem-error").hide();

        if (!$("#cart-redeem-quote-ref").val()) {
            $("#cart-redeem-error").html('Quote # required.');
            $("#cart-redeem-error").show();
        }
        else{
            var ref=$("#cart-redeem-quote-ref").val();
            ref=ref.toUpperCase();

            // const regex = /^Q\d+$/;
            // if (regex.test(ref)) {
                $.ajax({
                    type: 'POST',
                    url: '/api/form/claimquote/',
                    cache: false,
                    data: {"ref": ref},
                    dataType: 'json',
                })
                .done(function(data){
                    if(data.error){
                        $("#cart-redeem-error").html(data.msg);
                        $("#cart-redeem-error").show();
                    }
                    else{
                        window.location = '/checkout/';
                    }
                });
            // } else {
            //     $("#cart-redeem-error").html('Quote # should be in the format Q######.');
            //     $("#cart-redeem-error").show();
            // }
        }
    });

    $(document).ready(function() {
        updateCartCount();
    });
    
    function updateCartCount(){
        $.ajax({
            type: 'GET',
            url: '/api/view/itemcount',
            cache: false,
            dataType: 'json',
        })
        .done(function(data){
            if(data.count){
                $("#header-item-count").show();
                $("#header-item-count").html(data.count);
            }
            else{
                $("#header-item-count").hide();
            }
            setTimeout(function(){
                updateCartCount();
            }, 10000);
        });
    }

    if (typeof recaptchascript == 'undefined') {
        Array.from(document.querySelectorAll("form")).forEach((form, index) => {
            let input = form.querySelector(`input[name="CaptchaToken"]`);
        
            if (input) {
                let captcha = document.createElement("div");
                captcha.className = "g-recaptcha";
                captcha.dataset.callback = "captchaCallback_" + index;
                captcha.dataset.sitekey = input.dataset.key;
        
                input.after(captcha);
        
                globalThis[`captchaCallback_${index}`] = token => input.value = token;
            }
        });
        
        let recaptchascript = document.createElement("script");
        recaptchascript.src = "https://www.google.com/recaptcha/api.js";
        document.body.appendChild(recaptchascript);
    }
